import React from 'react';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import { Box, Typography } from '@mui/material';
import LegalLayout, { Section, P } from './LegalLayout';

export default function RefundPolicy() {
  return (
    <LegalLayout
      title="Refund & Cancellation Policy"
      updated="Last updated: 25 July 2026 · Home Billing POS billing"
      icon={AssignmentReturnIcon}
    >
      <Section title="1. Software subscription refunds">
        <P>
          Home Billing POS provides digital software licenses and owner-portal services. New customers may
          request a full refund within <strong>7 days</strong> of first paid activation if the software does
          not meet operational requirements, subject to verification that the request is made in good faith
          and that paid entitlements are revoked after refund.
        </P>
        <P>
          The free trial period (where offered) does not require payment; trial-only use is not a paid
          refund scenario.
        </P>
      </Section>

      <Section title="2. Cancellation">
        <P>
          You may stop using paid features or request cancellation by emailing
          support@homebillingpos.com. Branch and plan entitlements generally remain active until the end of
          the paid period already purchased unless we agree otherwise in writing.
        </P>
      </Section>

      <Section title="3. Branch add-on payments">
        <P>
          Payments for additional branches (e.g. annual branch fees) are for digital entitlements. Refunds
          for branch add-ons after successful activation are discretionary and generally not available
          once the branch has been provisioned and used, except where required by law or within the 7-day
          new-subscription window above.
        </P>
      </Section>

      <Section title="4. Hardware">
        <P>
          Physical hardware (printers, scanners, cash drawers) sold by third parties is subject to those
          sellers&apos; and manufacturers&apos; warranty and return policies. We are not the manufacturer of
          third-party hardware unless your invoice states otherwise.
        </P>
      </Section>

      <Box>
        <Typography variant="h6" fontWeight={700} gutterBottom color="primary.main">
          5. Processing time
        </Typography>
        <P>
          Approved refunds are returned to the original payment method within approximately 5–7 business
          days, depending on your bank or payment provider.
        </P>
        <P>
          Contact: support@homebillingpos.com or +91 98677 65397 (subject: Refund request).
        </P>
      </Box>
    </LegalLayout>
  );
}
